import React, { useState } from 'react';
import { MessageTurn, TranscriptMessage } from './MessageTurn';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { CommentSection } from './CommentSection';
import { SessionDetailView, viewCanSeeComments } from '../../History/views';
import { SpeechTurn } from 'interfaces/sessions';
import { PartyRole } from 'interfaces/db';

interface TranscriptRowProps {
  turn: SpeechTurn;
  index: number;
  isSelected: boolean;
  hasComment: boolean;
  onClick: () => void;
  sessionId: string;
  view: SessionDetailView;
}

export const TranscriptRow: React.FC<TranscriptRowProps> = ({
  turn,
  index,
  isSelected,
  hasComment,
  onClick,
  sessionId,
  view
}) => {
  const [showCommentSection, setShowCommentSection] = useState(false);
  const [showCommentInput, setShowCommentInput] = useState(false);
  
  // Get session data from Redux store to access comments
  const sessionData = useSelector((state: RootState) => 
    state.sessionDetails.sessionIdToDetails[sessionId]?.data
  );
  
  // Get comments for this transcript
  const comments = sessionData?.comments?.filter(
    comment => comment.transcriptIdx === index
  ) || [];
  
  // Convert SpeechTurn to TranscriptMessage format
  const message: TranscriptMessage = {
    ...turn,
    hasComment: hasComment,
    commentCount: comments.length
  }

  if (message.text.trim() === '') {
    return null;
  }

  const handleCommentIconClick = () => {
    setShowCommentSection(true);
    // If there are no comments, immediately show the comment input
    if (comments.length === 0) {
      setShowCommentInput(true);
    }
  };

  const handleCloseCommentSection = () => {
    setShowCommentSection(false);
    setShowCommentInput(false);
  };

  return (
    <div className="relative group" data-transcript-idx={index}>
      <div className={`px-4 py-1 ${isSelected ? 'bg-gray-100' : ''}`}>
        <MessageTurn
          view={view}
          key={`${message.start}-${index}`}
          message={message}
          isSelected={isSelected}
          onClick={onClick}
          onCommentClick={handleCommentIconClick}
        />
      </div>

      {/* Comment Section */}
      {showCommentSection && viewCanSeeComments(view) && (
        <CommentSection
          sessionId={sessionId}
          transcriptIdx={index}
          comments={comments}
          position={message.role === PartyRole.PROSPECT ? 'left' : 'right'}
          onClose={handleCloseCommentSection}
          showCommentInput={showCommentInput}
        />
      )}
    </div>
  );
}; 